import { validationErrors } from "../utils";
import ajaxService from "./ajax-service";

class RoleService {
    async fetch() {
        const response = await ajaxService.get(`/roles`);
        if (response?.success ?? false) {
            return response
        } else {
            const errors = response.data.errors;
            return validationErrors(errors);
          }
    }

    async view(id) {
        const response = await ajaxService.get(`/roles/${id}`);
        if (response?.success ?? false) {
            return response
        } else {
            const errors = response.data.errors;
            return validationErrors(errors);
          }
    }

    async add(data) {
        const response = await ajaxService.post('/roles', data);
        if (response?.success ?? false) {
            return response
        } else {
            const errors = response.data.errors;
            return validationErrors(errors)
        }
    }

    async assignPermissions(id, data) {
        const response = await ajaxService.post(`/roles/${id}/permissions`, data);
        if (response?.success ?? false) {
            return response
        } else {
            const errors = response.data.errors;
            return validationErrors(errors)
        }
    }

    async edit(id, data) {
        const response = await ajaxService.put(`/roles/`, id, data);
        if (response?.success ?? false) {
            return response
        } else {
            const errors = response.data.errors;
            return validationErrors(errors)
        }
    }

    async delete(id) {
        const response = await ajaxService.delete(`/roles/`, id)

        if (response?.success ?? false) {
            return response
        }
    }
}

const roleService = new RoleService();
export default roleService;